import "./about-us-hero-section.css";
import { useNavigate } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";

export default function AboutUsHeroSection() {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const goToContact = () => {
    navigate("/contact-us");
  };

  return (
    <div className="about-us-image-section">
      <div className="about-us-glass-blur-effect">
        <h6 className="main-heading">{t("About Us")}</h6>
        <h1 className="main-sub-heading">
          <Trans i18nKey={"A Chronicle of Innovation and Success"}>
            A Chronicle of <br/> Innovation and Success
          </Trans>
        </h1>
        <p className="main-description">
          {t("We evolved from being a startup established in 2020 to emerging as a global influencer in digital transformation services, targeted advancement of niche products, IT solutions, and advisory services for management processes.")}
        </p>
        <button
          type="button"
          className="about-contact-btn"
          onClick={goToContact}
        >
          {t("Contact Us")}
        </button>
      </div>
    </div>
  );
}
